import { TRequiredCodec, required } from "../../shared/src/codecs/types/required";

export const EmptyObject: TRequiredCodec<{}> = required({});
export type TEmptyObjectCodec = typeof EmptyObject;